import countStringLength from './count-string-length';
import trimString from './trim-string';

export { countStringLength, trimString };
